// selection-data.js - shared category + colour constants for the Selection
// Trainings module. selection.js (director report) and selection-coach.js
// (trainer rating UI) both read from here so the keys / labels can't drift.
// Mirrors evaluation-data.js for the main evaluation module.


export const SELECTION_DATA = (() => {

  const COLOR_LABELS = {
    pink:       'Pink',
    orange:     'Orange',
    royal_blue: 'Royal Blue',
    yellow:     'Yellow',
  };

  // Field-bib technical sub-skills. Tap +/- on each during a session.
  const TECH = [
    { key: 'tech_ball_carrying', label: 'Ball carrying'    },
    { key: 'tech_receiving',     label: 'Receiving'         },
    { key: 'tech_passing',       label: 'Passing'           },
    { key: 'tech_elimination',   label: 'Elimination (1v1)' },
    { key: 'tech_defensive',     label: 'Defensive skills'  },
    { key: 'tech_finishing',     label: 'Finishing'         },
  ];

  // Goalkeeper bibs swap the 6 technical sub-skills for GK-shaped ones.
  // Condensed from the full GK rubric - selection marking is a fast +/- on
  // observed actions; outcome skills like "Ability to keep it out" belong
  // to the longer evaluation rubric, not this quick format.
  const GK_TECH = [
    { key: 'gktech_set_position', label: 'Set position' },
    { key: 'gktech_positioning',  label: 'Positioning'  },
    { key: 'gktech_pad_saves',    label: 'Pad saves'    },
    { key: 'gktech_hand_saves',   label: 'Hand saves'   },
    { key: 'gktech_stick_saves',  label: 'Stick saves'  },
    { key: 'gktech_single_slide', label: 'Single slide' },
  ];

  // Pillar-level categories shared by field and GK bibs.
  const OTHER = [
    { key: 'tactical',        label: 'Tactical'          },
    { key: 'physical_mental', label: 'Physical / Mental' },
  ];

  const ALL          = [...TECH,    ...OTHER];
  const GK_ALL       = [...GK_TECH, ...OTHER];

  // Label lookup spans both rubrics - keys never overlap.
  const LABEL = Object.fromEntries(
    [...ALL, ...GK_TECH].map(c => [c.key, c.label])
  );

  // Right category set for a bib - GK for keepers, field otherwise.
  const allFor    = (bib) => (bib && bib.is_goalkeeper) ? GK_ALL  : ALL;
  const techFor   = (bib) => (bib && bib.is_goalkeeper) ? GK_TECH : TECH;

  return {
    COLOR_LABELS,
    TECH, GK_TECH, OTHER,
    ALL, GK_ALL,
    LABEL,
    allFor, techFor,
  };

})();
